// extracted by css-extract-rspack-plugin
export default {"container":"status-picker-module__container__f1nev"};